import { AfterViewInit, Component, ViewChild, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './core/components/header/header.component';
import { SpinnerComponent } from './core/components/spinner/spinner.component';
import { HeaderService } from './core/services/header.service';
import { ToastService } from './core/services/toast.service';
import { ToastComponent } from './shared/components/toast/toast.component';
// A aplicação roda embutida num iframe do portal: o child avisa o container a
// cada mudança de altura, para o iframe acompanhar o conteúdo em vez de cortar
// a página ou abrir uma segunda barra de rolagem. Importado pelo efeito
// colateral — é ele que registra `window.parentIFrame`, usado pelo toast.
import '@iframe-resizer/child';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SpinnerComponent, ToastComponent, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
  private readonly toastService = inject(ToastService);

  /** Lido pelo template: quem decide se a faixa de marca aparece é o portal. */
  protected readonly headerService = inject(HeaderService);

  @ViewChild(ToastComponent) toastComponent!: ToastComponent;

  // O toast é único na aplicação e vive no shell; quem avisa é o `ToastService`,
  // que só consegue fazê-lo depois que a view existe.
  ngAfterViewInit(): void {
    this.toastService.setToastComponent(this.toastComponent);
  }
}
